// extracted by mini-css-extract-plugin
export default {"block":"DeleteBlock_block__J+XB3","trash":"DeleteBlock_trash__k9Wfm"};